<template>
  <div class="indexbox">
    <!-- <el-alert
      title="iProX新版上线啦！新版本增加了丰富的统计功能：首页增加了按物种、仪器、疾病、组织器官、细胞类型统计的已发布项目的数据量；Statistics页面中增加了各种类型的统计。欢迎大家查阅！"
      type="success"
      :closable="false">
    </el-alert> -->
    <div class="noticediv">
      <i class="fa fa-volume-up mr5" /><span>The new iProX portal is now online! The homepage has added entries for species, instruments, diseases, tissues and organs, and cell types; the Statistics page presents more statistical data.</span>
    </div>
    <el-row :gutter="20" style="display:flex;justify-content: space-between;margin-top: 10px;">
      <el-col :span="19">
        <div class="main-contents">
          <h4>Integrated Proteome Resources</h4>
          <p>
            <span id="con1">iProX is an integrated proteome resources center in China, which is built to accelerate the worldwide data sharing in proteomics. iProX is composed of a data submission system and a proteome database. The submission system is established under the guidance of the data-sharing policy made by ProteomeXchange consortium. Registered users can submit their proteomic datasets to iProX in public or private modes. Once an associated manuscript has been published, a dataset becomes automatically public. <br></span>
            <br>
            <span>It is recommended to use the latest version of <a hrefhmv006.ibs="iProX" basic="" statistics="http://www.firefox.com.cn/">Firefox </a> or <a href="http://www.google.cn/chrome/browser/desktop/index.html">Chrome </a> browser.Please refer to the simple user <a target="_blank" onclick="window.location.href=jsonServer+&quot;page/helpEn.html&quot;">manual</a> for the new iProX.<br></span>
            <br>
            <span id="UserMannual">As an official member of <a href="http://www.proteomexchange.org/">ProteomeXchange</a> Consortium, iProX will assign ProteomeXchange identifiers (PXD) to datasets submitted to iProX.</span>
            <span id="NARreference">When using iProX, please cite the following reference: <br>
            <br>
            <span style="color:#a94442">Ma J, Chen T, Wu S, Yang C, Bai M, Shu K, Li K, Zhang G, Jin Z, He F, Hermjakob H, Zhu Y. iProX: an integrated proteome resource. Nucleic Acids Res. 2019; 47(D1): D1211-D1217. <br></span>
            <br>
            Chen T, Ma J, Liu Y, Chen Z, Xiao N, Lu Y, Fu Y, Yang C, Li M, Wu S, Wang X, Li D, He F, Hermjakob H, Zhu Y. iProX in 2021: connecting proteomics data sharing with big data. Nucleic Acids Res. 2022; 50(D1): D1522-D1527.
            <!-- <br>
            <br>
            Please refer to <a href="https://www.iprox.org/page/iproxDataLisence.html" target="_blank">iProX data license</a> and <a href="https://www.iprox.org/page/CNHPPDataLisence.html" target="_blank">CNHPP data license (in Chinese)</a>. -->
            </span>
          </p>
        </div>
      </el-col>
      <el-col :span="5">
        <!-- <el-collapse v-model="activeName" accordion @change="handleStatistics">
          <el-collapse-item title="Species" name="1">
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in speciesList" :key="index">
                <span class="badge">{{item.object_num}}</span>
                {{item.object_value}}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="Diseases" name="4">
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in diseasesList" :key="index">
                <span class="badge">{{item.object_num}}</span>
                {{item.object_value}}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="Tissues" name="2">
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in tissuesList" :key="index">
                <span class="badge">{{item.object_num}}</span>
                {{item.object_value}}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="Cell Types" name="3">
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in celltypesList" :key="index">
                <span class="badge">{{item.object_num}}</span>
                {{item.object_value}}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="Instruments" name="9">
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in instrumentsList" :key="index">
                <span class="badge">{{item.object_num}}</span>
                {{item.object_value}}
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse> -->
        <div class="tabgroup">
          <div class="tabgroup-module">
            <div class="tabgroup-module-header">
              <span @click="handleOpenStat('1', '')">Species</span>
              <i :class="isShow1 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleOpen('1')"/>
            </div>
            <div class="tabgroup-module-contents" v-if="isShow1">
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in speciesList" :key="index">
                  <span class="badge">{{item.object_num}}</span>
                  <span class="pointer" @click="handleOpenStat('1', item.object_value)">{{item.object_value}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="tabgroup-module">
            <div class="tabgroup-module-header">
              <span @click="handleOpenStat('4', '')">Diseases</span>
              <i :class="isShow4 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleOpen('4')" />
            </div>
            <div class="tabgroup-module-contents" v-if="isShow4">
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in diseasesList" :key="index">
                  <span class="badge">{{item.object_num}}</span>
                  <span class="pointer" @click="handleOpenStat('4', item.object_value)">{{item.object_value}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="tabgroup-module">
            <div class="tabgroup-module-header">
              <span @click="handleOpenStat('2', '')">Tissues</span>
              <i :class="isShow2 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleOpen('2')" />
            </div>
            <div class="tabgroup-module-contents" v-if="isShow2">
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in tissuesList" :key="index">
                  <span class="badge">{{item.object_num}}</span>
                  <span class="pointer" @click="handleOpenStat('2', item.object_value)">{{item.object_value}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="tabgroup-module">
            <div class="tabgroup-module-header">
              <span @click="handleOpenStat('3', '')">Cell Types</span>
              <i :class="isShow3 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleOpen('3')" />
            </div>
            <div class="tabgroup-module-contents" v-if="isShow3">
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in celltypesList" :key="index">
                  <span class="badge">{{item.object_num}}</span>
                  <span class="pointer" @click="handleOpenStat('3', item.object_value)">{{item.object_value}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="tabgroup-module">
            <div class="tabgroup-module-header">
              <span @click="handleOpenStat('9', '')">Instruments</span>
              <i :class="isShow9 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleOpen('9')" />
            </div>
            <div class="tabgroup-module-contents" v-if="isShow9">
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in instrumentsList" :key="index">
                  <span class="badge">{{item.object_num}}</span>
                  <span class="pointer" @click="handleOpenStat('9', item.object_value)">{{item.object_value}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="display: flex;margin-bottom: 50px;margin-top: 10px;">
      <el-col :span="12" style="flex: 1;">
        <div class="condata">
          <h4 class="block" id="ibs">iProX Basic Statistics</h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span id="con2">The iProX database currently contains:</span><br>
                <a href="javascript:;" @click="handlelinkTo('project')">
                  <span id="projectCount">{{countData.totalPro}} </span> <span id="projects">Projects</span>
                  <span id="publicProjectCount"> ({{countData.totalPublicPro}} </span><span id="publicProjects">Public Projects)</span>
                </a>
                <br>
                <a href="javascript:void(0)" @click="handlelinkTo('subproject')">
                  <span id="subProjectsCount">{{countData.totalSubPro}} </span> <span id="subProjects">Subprojects</span>
                  <span id="publicSubProjectCount"> ({{countData.totalSubPublicPro}} </span><span id="publicSubProjects">Public SubProjects)</span>
                </a>
                <br>
                <a href="javascript:;" @click="handlelinkTo('dataFiles')">
                  <span id="datafilesCount">{{countData.totalDataFile}} </span> <span id="dataFiles">Data Files</span>
                  <span id="publicDataFileCount"> ({{countData.totalPublicDataFile}} </span><span id="publicDataFiles">Public Data Files)</span>
                </a>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span id="con2New">The iProX data files currently contains:</span><br>
                <span id="week">last week:</span><span id="weekCount"> {{countData.weekFile}} </span>
                <span id="dataFiles1">Data Files</span><span id="weekSize"> ({{countData.weekSize}})</span><br>
                <span id="month">last month:</span><span id="monthCount"> {{countData.monthFile}} </span>
                <span id="dataFiles2">Data Files</span><span id="monthSize"> ({{countData.monthSize}}) </span><br>
                <span id="year">last year:</span><span id="yearCount"> {{countData.yearFile}} </span>
                <span id="dataFiles3">Data Files</span><span id="yearSize"> ({{countData.yearSize}}) </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12" style="flex: 1;">
        <div class="condata submitcon">
          <h4 class="block" id="sdti">Submit Data to iProX</h4>
          <p id="con3">iProX employs a web-based process of filling experimental information and uploading data files. iProX encourages and welcomes users to submit their proteome experiment raw data and meta-data, as well as protein and peptide identifications, which is to be published in peer-reviewed publications.</p>
          <p>
            <el-button class="submitbtn" @click="handleLinkmenu('https://test1.iprox.org.cn/page/PCV010.html')">Submit Data By Web</el-button>
            <!-- <a class="btn green" id="sdbw" href="https://www.iprox.cn/page/PCV010.html">Submit Data By Web</a> -->
          </p>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="contable">
      <el-col :span="24">
        <el-card class="box-card tablecard" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> The latest released projects</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <div>
            <!-- <el-table
              :data="projectData"
              stripe
              style="width: 100%">
              <el-table-column
                type="index"
                label="#"
                width="50">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="project_name"
                label="Project">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handleLinktoProject(scope.row.project_id)">{{scope.row.project_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fileCount"
                label="File Count (size)"
                width="100">
              </el-table-column>
              <el-table-column
                prop="lab_head"
                label="Lab Head"
                width="100">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="institution"
                label="Institution"
                width="500">
              </el-table-column>
              <el-table-column
                prop="sdate"
                label="Date"
                width="100">
              </el-table-column>
            </el-table> -->
            <el-table
            stripe
            empty-text="No Data"
            :data="projectData"
            style="width: 100%"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @expand-change="handleExpand">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    border
                    v-loading="loading2"
                    :data="props.row.subtableData"
                    style="width: 100%">
                    <!-- <el-table-column
                      prop=""
                      label=" "
                      width="50">
                    </el-table-column> -->
                    <el-table-column
                      prop="subtitle_en"
                      label="Subproject Title"
                      :show-overflow-tooltip="isOverflow">
                      <template slot-scope="scope">
                        <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                          {{scope.row.subtitle_en}}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="subproject_id"
                      label="Subproject ID"
                      width="130">
                    </el-table-column>
                    <el-table-column
                      prop="species"
                      label="Species"
                      width="200">
                    </el-table-column>
                    <el-table-column
                      prop="instrument"
                      label="Instrument"
                      width="200"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="fileCount"
                      label="File Count (size)"
                      width="140">
                    </el-table-column>
                    <el-table-column
                      prop="submit_time"
                      label="Release Date"
                      width="160">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="project_name"
                label="Project">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handleLinktoProject(scope.row.project_id)">{{scope.row.project_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fileCount"
                label="File Count (size)"
                width="100">
              </el-table-column>
              <el-table-column
                prop="lab_head"
                label="Lab Head"
                width="100">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="institution"
                label="Institution"
                width="500">
              </el-table-column>
              <el-table-column
                prop="sdate"
                label="Date"
                width="100">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20" class="contable mt15">
      <el-col :span="24">
        <el-card class="box-card tablecard" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> The latest released subprojects</span>
          </div>
          <div>
            <el-table
              :data="subprojectData"
              stripe
              style="width: 100%">
              <el-table-column
                type="index"
                label="#"
                width="50">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="subproject_name"
                label="Subproject">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handleLinktosubProject(scope.row.subproject_id)">{{scope.row.subproject_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fileCount"
                label="File Count (size)"
                width="100">
              </el-table-column>
              <el-table-column
                prop="lab_head"
                label="Lab Head"
                width="100">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="isOverflow"
                prop="institution"
                label="Institution"
                width="500">
              </el-table-column>
              <el-table-column
                prop="sdate"
                label="Date"
                width="100">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
    <el-row class="mt15">
      <div class="conlink">
        <img src="../assets/logo_ncpc.png" alt="">
        <img src="../assets/logo_bprc.png" alt="">
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getTopObjects, getLatestProjects, getLatestSubProjects, getBasicStat, getBrowseSubprojectList,
} from '@/api';

export default {
  name: 'home',
  data() {
    return {
      linkUrl: 'https://www.iprox.cn/',
      loading: false,
      activeName: '1',
      isOverflow: false,
      headerfixed: false,
      ajax_datasta: {
        filters: [{
          item: 'objecttype',
          equals: '1',
        }],
        page: { pageLength: 5, pageNum: 1 },
      },
      statiList: [],
      speciesList: [],
      diseasesList: [],
      tissuesList: [],
      celltypesList: [],
      instrumentsList: [],
      projectData: [],
      subprojectData: [],
      // countData: {},
      // weekData: [],
      // weekSize: 0,
      // monthData: [],
      // monthSize: 0,
      // yearData: [],
      // yearSize: 0,
      isShow1: true,
      isShow4: false,
      isShow2: false,
      isShow3: false,
      isShow9: false,
      countData: {
        weekFile: 0,
        weekSize: 0,
        monthFile: 0,
        monthSize: 0,
        yearFile: 0,
        yearSize: 0,
        totalPro: 0,
        totalPublicPro: 0,
        totalSubPro: 0,
        totalSubPublicPro: 0,
        totalDataFile: 0,
        totalPublicDataFile: 0,
      },
      ajax_data_BasicStat: {
        filters: [{
          item: 'objecttype',
          equals: '10',
        }],
      },
      ajax_data_pro: {
        page: {
          pageLength: 5,
          pageNum: 1,
        },
      },
      ajax_data_subpro: {
        page: {
          pageLength: 5,
          pageNum: 1,
        },
      },
      expands: [],
      getRowKeys(row) {
        return row.project_id;
      },
      loading2: true,
      ajax_data_sublist: {
        search: {
          sub: '',
        },
        page: {
          startPage: 1,
          pageLength: 20,
        },
        order: {
          item: '',
          type: '',
        },
      },
    };
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll', this.handleWheel);
  },
  created() {
    // getProjectList().then(res => {
    //   let newData = res
    //   newData.forEach((val, index) => {
    //     let fileCount = val.fileCount;
    //     let fileSize = this.handleFilesize(val.fileSize)
    //     val.fileCount = fileCount + fileSize
    //   })
    //   this.projectData = newData
    // })
    // getSubProjectList().then(res => {
    //   let newData = res
    //   newData.forEach((val, index) => {
    //     let fileCount = val.fileCount;
    //     let fileSize = this.handleFilesize(val.fileSize)
    //     val.fileCount = fileCount + fileSize
    //   })
    //   this.subprojectData = newData
    //   // this.subprojectData = res
    // })
    getBasicStat(this.ajax_data_BasicStat).then((res) => {
      // this.countData = res
      const dataResult = res.result;
      this.countData.weekFile = dataResult[0].object_num;
      this.countData.weekSize = dataResult[1].object_num;
      this.countData.monthFile = dataResult[2].object_num;
      this.countData.monthSize = dataResult[3].object_num;
      this.countData.yearFile = dataResult[4].object_num;
      this.countData.yearSize = dataResult[5].object_num;
      this.countData.totalPro = dataResult[6].object_num;
      this.countData.totalSubPro = dataResult[7].object_num;
      this.countData.totalDataFile = dataResult[8].object_num;
      this.countData.totalPublicPro = dataResult[9].object_num;
      this.countData.totalSubPublicPro = dataResult[10].object_num;
      this.countData.totalPublicDataFile = dataResult[11].object_num;
    });
    getLatestProjects(this.ajax_data_pro).then((res) => {
      // this.projectData = res.result
      const newData = res.result;
      newData.forEach((val, index) => {
        const fileCount = val.file_count;
        const fileSize = this.handleFilesize(val.file_size);
        val.fileCount = fileCount + fileSize;
      });
      this.projectData = newData;
    });
    getLatestSubProjects(this.ajax_data_subpro).then((res) => {
      const newData = res.result;
      newData.forEach((val, index) => {
        const fileCount = val.file_count;
        const fileSize = this.handleFilesize(val.file_size);
        val.fileCount = fileCount + fileSize;
      });
      this.subprojectData = newData;
      // this.subprojectData = res
    });
    // getFileWeekData().then(res => {
    //   this.weekData = res[0]
    //   let fileSize = this.handleFilesize(res[0].fileSize)
    //   this.weekSize = fileSize
    // })
    // getFileMonthData().then(res => {
    //   this.monthData = res[0]
    //   let fileSize = this.handleFilesize(res[0].fileSize)
    //   this.monthSize = fileSize
    // })
    // getFileYearData().then(res => {
    //   this.yearData = res[0]
    //   let fileSize = this.handleFilesize(res[0].fileSize)
    //   this.yearSize = fileSize
    // })
    this.handleStatistics('1');
  },
  watch: {},
  methods: {
    handleWheel() {
      const scrollTop = window.pageYOffset
          || document.documentElement.scrollTop
          || document.body.scrollTop;
      if (scrollTop >= 88) {
        this.headerfixed = true;
      } else {
        this.headerfixed = false;
      }
    },
    handleStatistics(activeName) {
      console.log(activeName);
      switch (activeName) {
        case '1':
          if (this.speciesList.length > 0) {
            return;
          }
          break;
        case '4':
          if (this.diseasesList.length > 0) {
            return;
          }
          break;
        case '2':
          if (this.tissuesList.length > 0) {
            return;
          }
          break;
        case '3':
          if (this.celltypesList.length > 0) {
            return;
          }
          break;
        case '9':
          if (this.instrumentsList.length > 0) {
            return;
          }
          break;
        default:
          if (this.statiList.length > 0) {
            return;
          }
          break;
      }
      this.ajax_datasta.filters[0].equals = activeName;
      getTopObjects(this.ajax_datasta).then((res) => {
        const resultData = res.result;
        switch (activeName) {
          case '1':
            this.speciesList = resultData;
            break;
          case '4':
            this.diseasesList = resultData;
            break;
          case '2':
            this.tissuesList = resultData;
            break;
          case '3':
            this.celltypesList = resultData;
            break;
          case '9':
            this.instrumentsList = resultData;
            break;
          default:
            this.statiList = resultData;
            break;
        }
      });
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = ` (${0}K)`;
      } else if (fileSize < 1024) {
        fileSize = ` (${fileSize.toFixed(2)}K)`;
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize = ` (${(fileSize / 1024).toFixed(2)}M)`;
      } else {
        fileSize = ` (${
          (fileSize / 1024 / 1024).toFixed(2)
        }G)`;
      }
      return fileSize;
    },
    handlelinkTo(param) {
      if (param == 'project') {
        this.$router.push({ path: '/browse', query: { id: 1 } });
        // location.href = this.linkUrl + "page/BWV016.html"
      } else if (param == 'subproject') {
        this.$router.push({ path: '/browse', query: { id: 2 } });
        // location.href = this.linkUrl + "page/BWV016.html?sublist=1"
      } else {
        this.$router.push({ path: '/browse', query: { id: 1 } });
        // location.href = this.linkUrl + "page/BWV016.html"
      }
    },
    handleLinktoProject(param) {
      // location.href = this.linkUrl + 'page/project.html?id=' + param
      this.$router.push({ path: '/project', query: { id: param } });
    },
    handleLinktosubProject(param) {
      this.$router.push({ path: '/subproject', query: { id: param } });
    },
    handleLinkmenu(param) {
      window.open(param);
    },
    handleOpen(param) {
      switch (param) {
        case '1':
          this.isShow1 = true;
          this.isShow4 = false;
          this.isShow2 = false;
          this.isShow3 = false;
          this.isShow9 = false;
          break;
        case '4':
          this.isShow1 = false;
          this.isShow4 = true;
          this.isShow2 = false;
          this.isShow3 = false;
          this.isShow9 = false;
          break;
        case '2':
          this.isShow1 = false;
          this.isShow4 = false;
          this.isShow2 = true;
          this.isShow3 = false;
          this.isShow9 = false;
          break;
        case '3':
          this.isShow1 = false;
          this.isShow4 = false;
          this.isShow2 = false;
          this.isShow3 = true;
          this.isShow9 = false;
          break;
        case '9':
          this.isShow1 = false;
          this.isShow4 = false;
          this.isShow2 = false;
          this.isShow3 = false;
          this.isShow9 = true;
          break;
        default:
          this.isShow1 = true;
          this.isShow4 = false;
          this.isShow2 = false;
          this.isShow3 = false;
          this.isShow9 = false;
          break;
      }
      this.ajax_datasta.filters[0].equals = param;
      getTopObjects(this.ajax_datasta).then((res) => {
        const resultData = res.result;
        switch (param) {
          case '1':
            this.speciesList = resultData;
            break;
          case '4':
            this.diseasesList = resultData;
            break;
          case '2':
            this.tissuesList = resultData;
            break;
          case '3':
            this.celltypesList = resultData;
            break;
          case '9':
            this.instrumentsList = resultData;
            break;
          default:
            this.statiList = resultData;
            break;
        }
      });
    },
    handleOpenStat(param1, param2) {
      if (param2 == '') {
        this.$router.push({ path: '/statistics', query: { params: param1 } });
      } else {
        this.$router.push({ path: '/statistics', query: { params: param1, subparams: param2 } });
      }
    },
    handleExpand(row, expandedRows) {
      this.loading2 = true;
      // console.log(row, expandedRows)
      this.expands = [];
      if (expandedRows.length) {
        expandedRows.map((item, key) => {
          this.expands.push(item.project_id);
        });
        this.ajax_data_sublist.search.project_id = row.project_id;
        this.ajax_data_sublist.page.startPage = 1;
        getBrowseSubprojectList(this.ajax_data_sublist).then((res) => {
          this.loading2 = false;
          const newData = res.result;
          newData.forEach((val, index) => {
            const fileCount = val.file_count;
            const fileSize = this.handleFilesize(val.file_size);
            val.fileCount = fileCount + fileSize;
          });
          const subList = newData;
          // console.log(subList)
          row.subtableData = subList;
        });
      } else {
        this.expands = [];
      }
    },
    handlesubProurl(param) {
      const routerData = this.$router.resolve({ path: '/subproject', query: { id: param } });
      window.open(routerData.href, '_blank');
    },
    // downloadFileList() {
    //     const resultList = [{
    //       "url": "https://download.iprox.cn/IPX0007905000/IPX0007905001/IPX0007905001.xml",
    //     }, {
    //       "url": "https://download.iprox.cn/IPX0007905000/IPX0007905000.xml",
    //     }]
    //   console.error(resultList)
    //   this.downloadFile(resultList,0)
    // },
    // downloadFile(list, index) {
    //     if (index < list.length) {
    //         console.error('下载第'+index+'个')
    //       var hiddenIFrameID = 'hiddenDownloader' + index;
    //       var iframe = document.createElement('iframe');
    //       iframe.id = hiddenIFrameID;
    //       iframe.className = 'hiddenIFrameClass';
    //       iframe.style.display = 'none';
    //       document.body.appendChild(iframe);
    //       iframe.src = list[index].url;//直接下载，不会弹出新的页面
    //         setTimeout(() => {
    //             index += 1
    //             this.downloadFile(list, index)
    //         },1000)
    //     } else {
    //       const elements = document.querySelectorAll('.hiddenIFrameClass');  // 替换 className 为要删除元素的 class 名称
    //       elements.forEach(element => element.remove());
    //     }
    // }
  },
};
</script>
<style lang="scss" scoped>
  .indexbox {

  }
  .noticediv {
    background-color: #f9f9f9;
    padding: 8px 20px;
    text-align: left;
    border: 1px solid #f9f9f9;
    border-radius: 4px;
    span {
      font-size: 14px;
      color: #d32c2c;
    }
  }
  .indexPage {
    width: 100%;
    overflow-x: hidden;
    height: auto;
  }
  // .el-main {
  //   background-color: #E9EEF3;
  //   color: #333;
  //   text-align: center;
  //   line-height: 160px;
  // }

  .el-main {
    background: #eff3f8;
    padding: 15px 0 15px;
    // height: calc(100vh - 205px);
    // overflow-y: scroll;
    .list-group {
      max-width: 400px;
      padding-left: 0;
      text-align: left;
      margin-top: 0;
      margin-bottom: 0;
      // color: #31708f;
      // .list-group-item:first-child {
      //   border-top-left-radius: 4px;
      //   border-top-right-radius: 4px;
      //   height: 20px;
      //   line-height: 20px;
      //   font-weight: 600;
      // }
      // .list-group-item:last-child {
      //   margin-bottom: 0;
      //   border-bottom-right-radius: 4px;
      //   border-bottom-left-radius: 4px;
      // }
      .list-group-item {
        position: relative;
        display: block;
        padding: 10px 15px;
        background-color: #D9EDF7;
        // background-color: #d9edf7;
        border: 1px solid #eff3f8;
      }
      .badge {
        display: inline-block;
        min-width: 10px;
        padding: 3px 7px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        background-color: #777;
        border-radius: 10px;
      }
      .list-group-item>.badge {
        float: right;
      }
    }
    .main-contents {
      padding: 15px;
      margin-bottom: 20px;
      border: 1px solid transparent;
      border-radius: 4px;
      background-color: #dff0d8;
      border-color: #d6e9c6;
      color: #3c763d;
      border-width: 1px;
      // height: auto;
      height: 445px;
      h4 {
        margin-top: 0;
        color: inherit;
        padding-top: 10px;
        padding-bottom: 10px;
        font-family: "Open Sans", sans-serif;
        font-weight: 400;
        text-align: left;
        font-size: 20px;
      }
      p {
        margin: 0 0 10px;
        margin-bottom: 0;
        text-align: left;
        font-size: 14px;
        line-height: 22px;
      }
    }
    .condata {
      background-color: #d9edf7;
      color: #31708f;
      padding: 15px;
      /*margin-bottom: 20px;*/
      border: 1px solid #bce8f1;
      border-radius: 4px;
      text-align: left;
      height: 100%;
      line-height: 27px;
      font-size: 14px;
      h4 {
        margin-top: 0;
        color: inherit;
        font-size: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: 400;
      }
      &-statics {
      }
      .submitbtn {
        color: #FFFFFF;
        background-color: #26a69a;
        float: right;
      }
    }
    // .contable {
    //   text-align: left;
    //   .tablecard {
    //     border: 1px solid #30d0c1;
    //   }
    // }
    .conlink {
      img {
        width: 220px;
        height: 60px;
      }
    }
    .tabgroup {
      &-module {
        color: #303133;
        &-header {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          height: 48px;
          line-height: 48px;
          cursor: pointer;
          border-bottom: 1px solid #ebeef5;
          font-weight: 500;
          -webkit-transition: border-bottom-color .3s;
          transition: border-bottom-color .3s;
          outline: 0;
          font-size: 20px;
          padding-left: 10px;
          background-color: #26a69a;
          color: #fff;
          border-radius: 4px;
          span {
          }
          i {
            margin: 0 8px 0 auto;
          }
        }
        &-contents {
          background-color: #d9edf7;
          padding-bottom: 0;
          font-size: 14px;
          color: #545758;
          line-height: 1.8;
        }
      }
    }
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .containerdiv {
    width: 1370px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  a {
    text-shadow: none;
    color: #5b9bd1;
    text-decoration: none;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt15 {
    margin-top: 15px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  /deep/.el-collapse-item__header {
    font-size: 20px;
    padding-left: 10px;
    background-color: #26A69A;
    color: #fff;
    border-radius: 4px;
  }
  /deep/.el-collapse-item__content {
    padding-bottom: 0;
    font-size: 14px;
    color: #545758;
  }
  /deep/.el-collapse-item__wrap {
    background-color: #D9EDF7;
  }
  h4 {
    font-family: "Open Sans", sans-serif;
    font-weight: 300;
  }
  /deep/.el-card {
    border: 1px solid #30d0c1;
  }
  /deep/.el-card__header {
    padding: 10px 20px;
    color: #fff;
    background-color: #26a69a;
    font-size: 20px;
  }
  /deep/ .el-dropdown-menu__item, .el-menu-item {
    font-size: 18px;
  }
  /deep/ .el-submenu__title {
    font-size: 18px;
  }

</style>
